export default "__VITE_PUBLIC_ASSET__2c6468b5__"